import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { showNotification } from 'store/actions/uiActions';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import {
    fetchProductProperties,
    fetchProductPropertiesFailure,
    fetchProductPropertiesSuccess,
    fetchProductPropertyFailure,
    fetchProductPropertySuccess,
} from 'store/actions/productProperties/fetchProductProperties';
import {
    createProductPropertyFailure,
    createProductPropertySuccess,
} from 'store/actions/productProperties/createProductProperties';
import {
    deleteProductPropertyFailure,
    deleteProductPropertySuccess,
} from 'store/actions/productProperties/deleteProductProperties';
import {
    updateProductPropertyFailure,
    updateProductPropertySuccess,
} from 'store/actions/productProperties/updateProductProperties';

function* fetchProductPropertiesAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/products/${ payload.productId }/properties`;

        const params = {
            'sort_by': 'priority',
            'sort_direction': 'desc',
        };

        const response = yield apiClient.read(url, params);

        yield put(fetchProductPropertiesSuccess(payload, response));
    } catch (error) {
        yield put(fetchProductPropertiesFailure(error));
    }
}

function* fetchProductPropertyAsync({ payload }) {
    const { productId, propertyId } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/products/${ productId }/properties/${ propertyId }`;

        // Fetch the data.
        const response = yield apiClient.read(url);

        yield put(fetchProductPropertySuccess(payload, response));
    } catch (error) {
        yield put(fetchProductPropertyFailure(error));
    }
}

// Create property groups.
function* createProductPropertyAsync({ payload }) {
    const { form, productId } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/products/${ productId }/properties`;

        // Post the data.
        const response = yield apiClient.create(url, form);

        // Trigger the product property success action.
        yield put(createProductPropertySuccess(payload, response));
    } catch (error) {
        // Trigger the error action.
        yield put(createProductPropertyFailure(error));
        yield payload.callback('error');
    }
}

function* createProductPropertySuccessAsync({ payload }) {
    const { productId, refresh } = payload;

    yield put(showNotification('notifications.products.property.create.success'));

    if (refresh) {
        yield put(push(`/products/${ productId }/properties/create`));

        if (payload.callback) {
            yield payload.callback();
        }
    } else {
        yield put(push(`/products/${ productId }/show`));
    }
}

// Update property groups.
function* updateProductPropertyAsync({ payload }) {
    const { form, productId, propertyId } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/products/${ productId }/properties/${ propertyId }`;

        // Post the data.
        const response = yield apiClient.patch(url, form);

        // Trigger the product property success action.
        yield put(updateProductPropertySuccess(payload, response));
    } catch (error) {
        // Trigger the error action.
        yield put(updateProductPropertyFailure(error));
        yield payload.callback();
    }
}

function* updateProductPropertySuccessAsync({ payload }) {
    const { productId } = payload;

    // Redirect the user to the correct page.
    yield put(push(`/products/${ productId }/show`));
    yield put(showNotification('notifications.products.property.update.success'));
}

// Delete product property.
function* deleteProductPropertyAsync({ payload }) {
    const { productId, propertyId } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/products/${ productId }/properties/${ propertyId }`;

        // Delete the data.
        yield apiClient.delete(url);

        // Trigger the property group action.
        yield put(deleteProductPropertySuccess(payload));
    } catch (error) {
        // Trigger the error action.
        yield put(deleteProductPropertyFailure(error));
    }
}

function* deleteProductPropertySuccessAsync({ payload }) {
    const { productId } = payload;

    yield put(fetchProductProperties({
        productId: productId,
    }));

    yield put(showNotification('notifications.products.property.delete.success'));
}

function* failureMessage({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

export default function* productPropertiesSagas() {
    yield [
        takeEvery('FETCH_PRODUCT_PROPERTIES', fetchProductPropertiesAsync),
        takeEvery('FETCH_PRODUCT_PROPERTIES_FAILURE', failureMessage),

        takeEvery('FETCH_PRODUCT_PROPERTY', fetchProductPropertyAsync),
        takeEvery('FETCH_PRODUCT_PROPERTY_FAILURE', failureMessage),

        takeEvery('CREATE_PRODUCT_PROPERTY', createProductPropertyAsync),
        takeEvery('CREATE_PRODUCT_PROPERTY_FAILURE', failureMessage),
        takeEvery('CREATE_PRODUCT_PROPERTY_SUCCESS', createProductPropertySuccessAsync),

        takeEvery('UPDATE_PRODUCT_PROPERTY', updateProductPropertyAsync),
        takeEvery('UPDATE_PRODUCT_PROPERTY_FAILURE', failureMessage),
        takeEvery('UPDATE_PRODUCT_PROPERTY_SUCCESS', updateProductPropertySuccessAsync),

        takeEvery('DELETE_PRODUCT_PROPERTY', deleteProductPropertyAsync),
        takeEvery('DELETE_PRODUCT_PROPERTY_FAILURE', failureMessage),
        takeEvery('DELETE_PRODUCT_PROPERTY_SUCCESS', deleteProductPropertySuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productPropertiesSagas.js